<template>
	<div>
		<!-- 引入top组件 -->
		<top :windowWidth="windowWidth" :windowHeight="windowHeight"></top>
		
		<topImage :windowWidth="windowWidth" :windowHeight="windowHeight" :image="$t('topImageUrl.contact')"/>
		
		<div style="margin-left: auto; margin-right: auto;max-width:900px;padding:2rem 1.5rem;" v-if="aboutList" >
			<p  style="width: 100%;" v-html="aboutList.contact" ></p>
			<baidu-map class="bm-view" :zoom="15" :center="center" inertial-dragging @ready="mapReady" :scroll-wheel-zoom="true">
				<bm-marker :position="endPoint" :dragging="true">
				    <bm-label content="中科卓软恒大时尚慧谷7栋F区418" :labelStyle="{ color: 'black', fontSize: '16px' }" :offset="{ width: -35, height: 30 }" />
				</bm-marker>
				<!-- 定位控件   anchor="BMAP_ANCHOR_BOTTOM_RIGHT"代表放在右下角 -->
				<bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true" @locationSuccess="positioning" ></bm-geolocation>
				<!-- 地图类型切换 -->
				<bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']" anchor="BMAP_ANCHOR_TOP_LEFT"></bm-map-type>
				<!-- 缩放控件   anchor代表控件停靠位置   anchor="BMAP_ANCHOR_TOP_RIGHT"代表放在右上角-->
				<bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
				<bm-driving :start="startPoint" :end="endPoint" :autoViewport="true" :panel="false" @searchcomplete="handleSearchComplete"  ></bm-driving>
				<bml-lushu @stop="reset" :play="play" :icon="icon" :path="path" :rotation="true" :speed="100" ></bml-lushu>
			</baidu-map>
				
		</div>
		
		<!-- 引入底部组件 -->
		<div v-if="windowWidth>=800">
			<bottom></bottom>
		</div>
		
		<right :windowWidth="windowWidth"></right>
	</div>
</template>

<script>
	import{BaiduMap, BmControl,BmView,BmAutoComplete,BmLocalSearch,BmMarker,BmGeolocation,BmlLushu} from "vue-baidu-map"
	import * as aboutApi from "@/api/home/about.js"
	import topImage from '@/components/topImage/topImage.vue'//引入top图片
	import top from '@/components/top/top.vue'; //引入top组件
	import bottom from '@/components/bottom/index.vue'; //引入bottom组件
	import right from '@/components/right/right.vue'; //引入bottom组件
	import {
		changeKeywords,
		changeDescription,
		changeTitle
	} from '@/utils/brower.js'
	export default {
		components: {
			top,
			bottom,
			right,
			topImage,
			BaiduMap,
			BmControl,
			BmView,
			BmAutoComplete,
			BmLocalSearch,
			BmMarker,
			BmGeolocation,
			BmlLushu,        
		},
		data() {
			return {
				// 浏览器窗口宽度高度
				windowWidth: 0,
				windowHeight: 0,
				aboutList:null,
				
				//定位位置信息
				keyword:null,
				play:false,
				path: [],
				center: {lng: 113.984069, lat:22.683133},
				startPoint: { lng: 113.984069,lat:22.683133 },
				endPoint: { lng: 113.984069, lat: 22.683133 },
				icon: {
				   url: 'http://api.map.baidu.com/library/LuShu/1.2/examples/car.png',
				   size: {width: 52, height: 26},
				   opts: {anchor: {width: 27, height:13}}     
				},
			}
		},
		
		created() {
			this.$i18n.locale = this.$store.state.language;
			this.getAbout()
		},
		
		updated() {
			window.scroll(0,this.$store.state.h_contact)
		},
		
		mounted() {
			let that = this;
			that.windowWidth = document.body.clientWidth;
			that.windowHeight = document.body.clientHeight;
			window.onresize = () => {
				return (() => {
					this.windowWidth = document.body.clientWidth;
					this.windowHeight = document.body.clientHeight;
				})();
			};
		},
		watch:{
			//双向绑定语言切换
			'$i18n.locale'(val) {
				this.getAbout()
				changeTitle(val=='cn'?'联系我们':'Contact')
				changeKeywords(this.$t('browerChange.keywords'))
				changeDescription(this.$t('browerChange.description'))
			}
		},
		
		beforeCreate() {
			changeTitle(this.$i18n.locale=='cn'?'联系我们':'Contact')
			changeKeywords(this.$t('browerChange.keywords'))
			changeDescription(this.$t('browerChange.description'))
		},
		
		methods:{
			//获取企业信息
			getAbout(){
				aboutApi.queryList({language:this.$i18n.locale == 'en'?'English':'中文'}).then(res=>{
					if(res.code == 200 && res.rows.length>0){
					  res.rows[0].contact = res.rows[0].contact.replace(/<img/g,"<img style='max-width:100%;height:auto;'")
					  res.rows[0].contact = this.HttpChange('URL',res.rows[0].contact)
					  this.aboutList = res.rows[0]
					}
				})
			},
			
			//地图加载后的回调
			mapReady({ BMap, map }){
			    // 获取自动定位方法
			    var geolocation = new BMap.Geolocation();
			    // 获取自动定位获取的坐标信息
			    geolocation.getCurrentPosition((res)=>{
			            //可以conso.log看一下这个r，他里面包含了检索到的位置信息。下面就把两个维度信息赋值给center来定位
			            this.center = {
			                lng: res.point.lng,
			                lat: res.point.lat,
			            }
						this.startPoint = {
						    lng: res.point.lng,
						    lat: res.point.lat,
						}
						this.play= true
			        },
			        { enableHighAccuracy: true }//启用高精度
			    );
			},
			
			reset() {
				this.play = false;
			},
			
			//轨迹
			handleSearchComplete(res) {
				this.path = res.getPlan(0).getRoute(0).getPath()
			},
			
			//定位
			positioning(res){
				this.center = {lng:res.point.lng,lat:res.point.lat}
				this.startPoint = {lng:res.point.lng,lat:res.point.lat}
				this.play= true
			}
			
		}
	}
</script>

<style lang="less">
	.bm-view {
	    height: 500px;
	    margin-top: 20px;
	    width: 100%;
	}
	.BMap_cpyCtrl {
	    display: none;
	  }
	.anchorBL {
		display: none;
	}
	
	
</style>